import type { SelectProps } from './Select';

import { useState } from 'react';
import { styled } from 'styled-components';

import ArrowDownIcon from '../../../../assets/icons/arrow-down.svg?react';
import { SecondaryButton } from '../../button/SecondaryButton';

import { Select } from './Select';

const SecondaryButtonSC = styled(SecondaryButton)`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const AnimatedIconSC = styled.span<{ $isOpen: boolean }>`
  transition: transform 0.5s;
  transform: ${(props) => (props.$isOpen ? `rotate(180deg)` : '')};
`;

export const IconSelect = ({ activeItemIndex, buttonProps, items, onItemChange }: SelectProps) => {
  const [isOpen, setIsOpen] = useState(false);

  if (items.length === 0) {
    throw new Error('Array of items cannot be empty');
  }

  const activeItem = items[activeItemIndex];

  return (
    <Select isOpen={isOpen} items={items} onItemChange={onItemChange} setIsOpen={setIsOpen}>
      <SecondaryButtonSC
        colorVariant="blue"
        leftIcon={activeItem.icon}
        rightIcon={
          <AnimatedIconSC $isOpen={isOpen}>
            <ArrowDownIcon />
          </AnimatedIconSC>
        }
        {...buttonProps}
      >
        {activeItem.abbreviation ?? activeItem.label}
      </SecondaryButtonSC>
    </Select>
  );
};
